var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperAirplaneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/paper-airplane"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M4.63247 3.02167C4.45791 2.96574 4.26961 3.01994 4.1421 3.16282C4.01459 3.30571 3.96842 3.51423 4.02188 3.70585L5.62558 9.45466H11.2404C11.5135 9.45466 11.7349 9.69886 11.7349 10.0001C11.7349 10.3013 11.5135 10.5455 11.2404 10.5455H5.62559L4.02194 16.2941C3.96848 16.4858 4.01465 16.6943 4.14216 16.8372C4.26968 16.9801 4.45798 17.0343 4.63253 16.9783C9.04919 15.5631 13.1507 13.3319 16.7942 10.4428C16.9234 10.3403 17 10.1755 17 9.99992C17 9.82436 16.9234 9.65953 16.7941 9.55705C13.1507 6.66798 9.04913 4.43682 4.63247 3.02167Z",
    fill: "#7A7888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplaneIcon);
export default __webpack_public_path__ + "static/media/PaperAirplaneIcon.393aa86b11dc3547436bf7ae412eca63.svg";
export { ForwardRef as ReactComponent };